import axios from 'axios'
import { getFormattedMoneyString, getLocalURL } from '../../../scripts/helpers/globale'

export default class SearchDesktop {
  constructor(component) {
    this.dom = {
      $component: component,
      $navigation: document.querySelector('.js-navigation'),
      $searchToggle: document.querySelectorAll('.js-toggleSearch'),
      $searchButton: document.querySelector('.js-searchButton'),
      $searchDrawer: document.querySelector('.js-searchDesktop'),
      $searchUnderlay: document.querySelector('.js-searchDesktopUnderlay'),
      $input: component.querySelector('.js-searchDesktopInput'),
      $resultsContainer: component.querySelector('.js-searchDesktopResults'),
    }
    this.state = {
      searchOpen: false,
      searchOpenClass: 'openSearchDesktop',
      underlayActiveClass: 'isActive',
      predictiveSearchTimeout: null,
      showResultsClass: 'showResults',
    }
    this.toggleSearchHandler = this.toggleSearch.bind(this)
    this.predictiveSearchHandler = this.predictiveSearch.bind(this)
    this.escapePressHandler = this.escapePress.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const { dom } = this
    dom.$searchToggle.forEach($toggle => $toggle.addEventListener('click', this.toggleSearchHandler))
    dom.$input.addEventListener('input', this.predictiveSearchHandler)
    window.addEventListener('keydown', this.escapePressHandler)
  }

  toggleSearch() {
    const { dom, state } = this

    if (state.searchOpen) {
      dom.$searchDrawer.setAttribute('aria-hidden', 'true')
      dom.$searchDrawer.setAttribute('aria-expanded', 'false')
      dom.$searchDrawer.classList.remove(state.searchOpenClass)
      dom.$searchButton.classList.remove(state.searchOpenClass)
      dom.$searchUnderlay.classList.remove(state.underlayActiveClass)
      setTimeout(() => {
        dom.$navigation.classList.remove(state.searchOpenClass)
      }, 500)
      state.searchOpen = false
    } else {
      dom.$searchDrawer.setAttribute('aria-hidden', 'false')
      dom.$searchDrawer.setAttribute('aria-expanded', 'true')
      dom.$searchDrawer.classList.add(state.searchOpenClass)
      dom.$searchButton.classList.add(state.searchOpenClass)
      dom.$navigation.classList.add(state.searchOpenClass)
      dom.$input.focus()
      dom.$searchUnderlay.classList.add(state.underlayActiveClass)
      state.searchOpen = true
    }
  }

  predictiveSearch(event) {
    const { state } = this
    clearTimeout(state.predictiveSearchTimeout)
    state.predictiveSearchTimeout = setTimeout(() => this.search(event.target.value), 500)
  }

  async search(value) {
    const { dom, state } = this

    if (!value) {
      dom.$searchDrawer.classList.remove(state.showResultsClass)
      return
    }

    try {
      const url = getLocalURL(`/search/suggest.json?q=${value}&resources[type]=product&resources[limit]=5&resources[options][fields]=product_type,tag,title,variants.barcode,variants.sku,variants.title,vendor`)
      const { data } = await axios.get(url)
      const products = data.resources.results.products

      if (products.length === 0) {
        dom.$searchDrawer.classList.remove(state.showResultsClass)
        return
      }

      dom.$searchDrawer.classList.add(state.showResultsClass)
      this.renderResults(products)
    } catch (event) {
      console.log(`Error searching "${value}"`, event)
    }
  }

  renderBadgeText(product) {
    let badgeText = ''

    if (product.tags) {
      const tags = product.tags

      for (const tag of tags) {
        const matchPromo = (/badge_promo:(.+)/).exec(tag)
        const match = (/badge:(.+)/).exec(tag)

        if (matchPromo) {
          badgeText = matchPromo[1]
          break
        }

        if (match) {
          badgeText = match[1]
        }
      }
    }

    const badgeWrapper = document.createElement('div')
    badgeWrapper.className = 'Badge'
    const badgeSpan = document.createElement('span')
    badgeSpan.innerText = badgeText
    badgeSpan.className = 'Badge__text'
    badgeWrapper.appendChild(badgeSpan)

    return badgeWrapper
  }

  renderResults(products) {
    const { dom } = this
    dom.$resultsContainer.innerHTML = ''

    products.forEach(product => {
      const { title, price, url } = product
      const imgSrc = product.featured_image.url
      const a = document.createElement('a')
      const image = new Image()
      const badgeWrapper = this.renderBadgeText(product)
      const priceInCents = (price * 100).toString()

      image.src = imgSrc
      image.alt = title
      a.className = 'SearchDesktop__item'
      a.href = url
      a.innerHTML = `
        <div class="SearchDesktop__item__img"></div>
        <span class="SearchDesktop__item__title btn-link">${title}</span>
        <span class="rmp">
          <span class="currency-formatting">
            ${getFormattedMoneyString(priceInCents)}
          </span>
        </span>
      `

      if (badgeWrapper.innerText) {
        a.querySelector('.SearchDesktop__item__img').appendChild(badgeWrapper)
      }

      image.addEventListener('load', () => {
        a.querySelector('.SearchDesktop__item__img').append(image)
      })
      dom.$resultsContainer.append(a)
    })
  }

  escapePress(event) {
    const { dom, state } = this

    if (event.keyCode !== 27) {
      return
    }
    if (state.searchOpen) {
      this.toggleSearch()
      dom.$searchButton.focus()
    }
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.SearchDesktop = this
  }
}
